import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(initReactI18next).init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: {
                rights: 'All rights reserved.',
                navigation: {
                    aboutus: 'About Us',
                    benefits: 'Our benefits',
                    howwework: 'How we work',
                    become: 'Become a distributor',
                    contactus: 'Contact Us',
                    becomeD: 'BECOME',
                    distributor: 'A DISTRIBUTOR',
                },
                contactForm: {
                    become: 'Become a partner',
                    of: 'of',
                    connect: 'Connect Stellar Bets today',
                    name: 'Name*',
                    email: 'Email*',
                    warning: 'incorrect filling *',
                    accepted: 'Your request has been accepted',
                    success: 'Your application has been accepted. Our manager will contact you as soon as possible',
                    opening: 'Opening hours: Mon-Fri, 10 am - 20pm',
                    close: 'Close',
                },
                title: {
                    start: 'START',
                    part1: 'YOUR OWN BUSINESS',
                    part2: 'TODAY',
                    part3: 'Bring fun and excitement in just a couple clicks',
                },
                reviewList: {
                    part1: {
                        title: 'Exceptional Game',
                        description:
                            'Team offers an incredible game. The graphics and gameplay are top-notch, making every session fun and engaging',
                    },
                    part2: {
                        title: 'Endless Game Choices',
                        description:
                            'From action-packed games to thrilling classics, the game has it all. There’s something for every kind of player here',
                    },
                    part3: {
                        title: 'Amazing Support Team',
                        description:
                            'The support team is fast and helpful. They made sure I had the best experience with their games',
                    },
                    part4: {
                        title: 'Immersive Gameplay',
                        description:
                            'The game delivers an unmatched gaming experience. The visuals and challenges keep me coming back for more every time!',
                    },
                    part5: {
                        title: 'Fun for Everyone',
                        description:
                            'The team offers games for every taste. Whether you love strategy or fast-paced action, you’ll find the perfect match here',
                    },
                },
                benefitTitle: 'Benefits',
                benefits: {
                    part1: {
                        title: 'Easy controll',
                        description: 'It is easy to manage, set up new accounts and configure gaming devices.',
                    },
                    part2: {
                        title: 'Manage Your Finances',
                        description:
                            'Track the financial transactions of all your gaming devices, track profits and make payments.',
                    },
                    part3: {
                        title: 'Full Support',
                        description: 'A complete guide to use and a fast support team ready to help in any situation.',
                    },
                },
                easyadministration: {
                    easy: 'Easy',
                    admin: 'Administration',
                    soft: 'Software included',
                    manage: 'Manage your gaming devices and view statistics',
                },
                instructionTitle: { part1: 'HOW TO BECOME A', part2: 'DISTRIBUTOR' },
                instructions: {
                    part1: {
                        title: 'Sign-Up',
                        description: 'Just reach out to us to get started. We’re here to support anyone ready to join',
                    },
                    part2: {
                        title: 'Receive',
                        description:
                            'Our team provides everything to be set up and ready to connect with clients in no time',
                    },
                    part3: {
                        title: 'Install',
                        description: 'You’re ready to attract clients and maximize your potential!',
                    },
                },
            },
        },
        fi: {
            translation: {
                rights: 'Kaikki oikeudet pidätetään.',
                navigation: {
                    aboutus: 'Meistä',
                    benefits: 'Etuudet',
                    howwework: 'Kuinka toimimme',
                    become: 'Ryhdy jakelijaksi',
                    contactus: 'Ota yhteyttä',
                    becomeD: 'RYHDY',
                    distributor: 'JAKELIJAKSI',
                },
                contactForm: {
                    become: 'Ryhdy kumppaniksi',
                    of: 'ja',
                    connect: 'Yhdistä Stellar Bets jo tänään',
                    name: 'Nimi*',
                    email: 'Sähköposti*',
                    warning: 'virheellinen täyttö *',
                    accepted: 'Pyyntösi on hyväksytty',
                    success: 'Hakemuksesi on hyväksytty. Hallintamme ottaa sinuun yhteyttä mahdollisimman pian',
                    opening: 'Aukioloajat: Ma-Pe, 10:00 - 20:00',
                    close: 'Sulje',
                },
                title: {
                    start: 'ALOITA',
                    part1: 'OMA LIIKETOIMINTASI',
                    part2: 'TÄNÄÄN',
                    part3: 'Tuo hauskuutta ja jännitystä vain muutamalla klikkauksella',
                },
                reviewList: {
                    part1: {
                        title: 'Poikkeuksellinen peli',
                        description:
                            'Tiimi tarjoaa uskomattoman pelin. Grafiikat ja pelattavuus ovat huipputasoa, mikä tekee jokaisesta pelikerrasta hauskan ja mukaansatempaavan',
                    },
                    part2: {
                        title: 'Loputtomasti pelivaihtoehtoja',
                        description:
                            'Toimintapeleistä jännittäviin klassikoihin – tältä peliltä löytyy kaikkea. Jokaiselle pelaajalle löytyy jotakin',
                    },
                    part3: {
                        title: 'Upea tukitiimi',
                        description:
                            'Tukitiimi on nopea ja avulias. He varmistivat, että sain parhaan kokemuksen heidän peleistään',
                    },
                    part4: {
                        title: 'Mukaansatempaava pelikokemus',
                        description:
                            'Tämä peli tarjoaa vertaansa vailla olevan pelikokemuksen. Visuaalisuus ja haasteet saavat minut palaamaan aina uudestaan!',
                    },
                    part5: {
                        title: 'Hauskaa kaikille',
                        description:
                            'Tiimi tarjoaa pelejä jokaiseen makuun. Olipa kyse strategiasta tai nopeatempoisesta toiminnasta, löydät täältä täydellisen vaihtoehdon',
                    },
                },
                benefitTitle: 'Etuudet',
                benefits: {
                    part1: {
                        title: 'Helppo hallinta',
                        description: 'Helppo hallita, luoda uusia tilejä ja konfiguroida pelilaitteita.',
                    },
                    part2: {
                        title: 'Hallitse talouttasi',
                        description:
                            'Seuraa kaikkien pelilaitteidesi taloudellisia tapahtumia, tarkkaile voittoja ja suorita maksuja.',
                    },
                    part3: {
                        title: 'Täysi tuki',
                        description:
                            'Täydellinen käyttöopas ja nopea tukitiimi, joka on valmis auttamaan kaikissa tilanteissa.',
                    },
                },
                easyadministration: {
                    easy: 'Helppo',
                    admin: 'Hallinta',
                    soft: 'Ohjelmisto sisältyy',
                    manage: 'Hallinnoi pelilaitteitasi ja tarkastele tilastoja',
                },
                instructionTitle: { part1: 'KUINKA RYHTYÄ', part2: 'JAKELIJAKSI' },
                instructions: {
                    part1: {
                        title: 'Rekisteröidy',
                        description:
                            'Ota vain yhteyttä meihin päästäksesi alkuun. Olemme täällä tukemassa kaikkia, jotka ovat valmiita liittymään',
                    },
                    part2: {
                        title: 'Vastaanota',
                        description:
                            'Tiimimme tarjoaa kaiken, mitä tarvitset päästäksesi alkuun ja yhdistääksesi asiakkaisiin nopeasti',
                    },
                    part3: {
                        title: 'Asenna',
                        description: 'Olet valmis houkuttelemaan asiakkaita ja maksimoimaan potentiaalisi!',
                    },
                },
            },
        },
    },
})

export default i18n
